<template>
    <div style="background-color: #fafafa;">
        <div class="searchBox">
            <van-search class="search-box" background="#2D7FC7" shape="round" v-model="value" :placeholder="searchHolder" show-action @search="onSearch()" @input="onSearch()"
                        @cancel="onSearch()" @clear="onSearch()">
                <div style="padding-top: 10px;" slot="action" @click="showCategoryPop()"><van-icon name="filter-o" size="20" color="#fafafa"/></div>
            </van-search>
        </div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh()">
            <van-list v-model="loading" :finished="finished" @load="getSkuList" class="listBox"  finished-text="没有更多了">
                <div v-for="item in list" class="card" :key="item.uuid" @click="openMainDetail(item)">
                    <table class="layout">
                        <tr>
                            <td style="width: 150px;">
                                <van-image
                                        width="150"
                                        height="100"
                                        :src="item.imageUrl"
                                />
                            </td>
                            <td style="padding-left: 10px;">
                                <p>
                                    <span style="font-size: 16px; font-weight: bold">{{item.name}}</span>
                                </p>
                                <p>
                                    <span>代码:</span>
                                    <span>{{item.code}}</span>
                                </p>
                                <p>
                                    <span style="font-size: 14px; font-weight: bold; color: #ff3300">¥{{item.price}}</span>
                                </p>
                            </td>
                        </tr>
                    </table>
                </div>
            </van-list>
        </van-pull-refresh>
        <van-popup v-model="showCategory" closeable position="bottom" :style="{ height: '80%' }"
                   :close-on-click-overlay="false">
            <van-nav-bar title="请选择暖气分类" left-text="取消" @click-left="onCategoryClickLeft()" />
            <van-search placeholder="请输入搜索关键词" v-model="categoryValue" @input="onCategorySearch()" @search="onCategorySearch()"/>
            <van-list @load="getSkuCategoryList()" :finished="categoryFinished" id="categoryList" finished-text="没有更多了">
                <van-cell v-for="item in categoryList" :key="item.uuid" :title="item.name" @click="setCategoryId(item.uuid, item.name)"></van-cell>
            </van-list>
        </van-popup>
        <div class="recordBox">
            <table style="width: 100%;margin-bottom: 3px;border-spacing:0;">
                <tr style="height:35px;padding: 0;">
                    <td style="width: 50%;background-color:#1989fa;" >
                        <van-button type="info" native-type="button" size="large" @click="goToCart()">购物车<span v-if="cartQuantity">({{cartQuantity}})</span></van-button>
                    </td>
                    <td style="width: 50%;background-color:#ee0a24;" >
                        <van-button type="danger" native-type="button" size="large" @click="goToMyOrder()">我的订单</van-button>
                    </td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
    import { Panel, Cell, Image, Field, List, Search, Popup, PullRefresh, NavBar, Icon, Button} from 'vant';
    import dealerOrderService from "../../service/dealerOrderService";
    import dictionaryService from "../../service/dictionaryService";
    import {API_URL} from "../../common/config";
    import configService from "../../service/configService";

    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                value: '',
                refreshing: false,
                searchHolder: "请输入型号或代码",
                showCategory: false,
                categoryList: [],
                categoryLoading: false,
                categoryFinished: false,
                categoryPageIndex: 0,
                categoryValue: '',
                categoryRefreshing: false,
                groupId: "",
                categoryId: "",
                isLeader: "",
                dealerId: "",
                imageUrl: API_URL + "/oa/common/attachment/showImage?id=",
                cartQuantity: "",
                groupBack: false
            }
        },
        components: {
            [Panel.name]: Panel,
            [Field.name]: Field,
            [List.name]: List,
            [Icon.name]: Icon,
            [Search.name]: Search,
            [Popup.name]: Popup,
            [Cell.name]: Cell,
            [Image.name]: Image,
            [NavBar.name]: NavBar,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh
        },
        created: async function () {
            let resp = await dealerOrderService.getDealerInfo();
            if (resp.data.Status === "1") {
                if(resp.data.Data){
                    this.groupBack = true;
                    this.groupId = resp.data.Data.priceGroupId || "";
                    this.isLeader = resp.data.Data.isLeader || "2";
                    this.dealerId = resp.data.Data.uuid || "0";
                }else{
                    let configResp = await configService.getConfigByName("业务员默认价格组");
                    if (configResp.data.Status === "1"){
                        this.groupBack = true;
                        if (configResp.data.Data){
                            this.groupId = configResp.data.Data.value || "";
                            this.isLeader = "2";
                            this.dealerId = "0";
                        }
                    }
                }
                this.onRefresh();
            }
            resp = await dealerOrderService.getCartQuantity("");
            if (resp.data.Status === "1") {
                this.cartQuantity = resp.data.Data || "";
            }
        },
        methods: {
            async getSkuList() {
                if(this.groupBack){
                    this.pageIndex++;
                    let resp = await dealerOrderService.getRadSkuList(this.pageIndex, this.categoryId, this.groupId, this.isLeader, this.value);
                    if (resp.data.Status === "1"){
                        resp.data.Data.data.forEach(item => {
                            item.imageUrl = this.imageUrl + item.imageIds.split(",")[0];
                        });
                        this.loading = false;
                        this.refreshing = false;
                        this.list = [...this.list, ...resp.data.Data.data];
                        this.finished = resp.data.Data.total <= this.list.length;
                    }
                }else{
                    let tempResp = await dealerOrderService.getDealerInfo();
                    if (tempResp.data.Status === "1") {
                        if(resp.data.Data){
                            this.groupBack = true;
                            this.groupId = resp.data.Data.priceGroupId || "";
                            this.isLeader = resp.data.Data.isLeader || "2";
                            this.dealerId = resp.data.Data.uuid || "0";
                            await this.getSkuList();
                        }else{
                            let configResp = await configService.getConfigByName("业务员默认价格组");
                            if (configResp.data.Status === "1"){
                                this.groupBack = true;
                                if (configResp.data.Data){
                                    this.groupId = configResp.data.Data.value || "";
                                    this.isLeader = "2";
                                    this.dealerId = "0";
                                }
                                await this.getSkuList();
                            }
                        }
                    }
                }
            },

            onRefresh(){
                this.list = [];
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.getSkuList();
            },
            onSearch(){
                this.onRefresh();
            },

            async getSkuCategoryList() {
                this.categoryPageIndex++;
                let resp = await dictionaryService.getOptions("rad_sku_category", this.categoryPageIndex, 10, "level=1",
                    this.categoryValue, "");
                if (resp.data.Status === "1"){
                    this.categoryLoading = false;
                    this.categoryRefreshing = false;
                    this.categoryList = [...this.categoryList, ...resp.data.Data];
                    this.categoryFinished = resp.data.Data.length < 10;
                }
            },

            onCategoryRefresh(){
                this.categoryList = [];
                this.categoryFinished = false;
                this.categoryLoading = true;
                this.categoryPageIndex = 0;
                this.getSkuCategoryList();
            },
            onCategorySearch(){
                this.onCategoryRefresh();
            },

            setCategoryId(uuid, name){
                this.showCategory = false;
                this.categoryId = uuid;
                this.searchHolder = name;
                this.onSearch();
            },

            showCategoryPop(){
                this.showCategory = true;
            },

            onCategoryClickLeft(){
                this.showCategory = false;
                if(this.categoryId){
                    this.categoryId = "";
                    this.searchHolder = "请输入型号或代码";
                    this.onSearch();
                }
            },
            openMainDetail(item){
                this.$router.push({path:"radDetail",  query:{radId: item.uuid, groupId: this.groupId}} );
            },
            goToCart(){
                this.$router.push("radCart");
            },
            goToMyOrder(){
                this.$router.push("radOrder");
            },
        }
    };
</script>

<style>
    .search-box {
        margin-top: 0;
    }
    .listBox{
        width: 100%;
        margin-top: 10px;
    }
    .card p {
        margin:10px 0;
    }
    .card p>span:first-child {
        flex: 0 0 4rem;
        text-align: right;
        margin-right: 20px;
    }
    .van-pull-refresh__head{
        display: none;
    }
    .van-pull-refresh{
        margin-top: 3rem;
    }
    .recordBox {
        box-sizing: border-box;
        margin-top: 2rem;
        bottom:0;
        position:fixed;
        width: 100%;
    }

    .searchBox {
        height: 3rem;
        box-sizing: border-box;
        margin-bottom: 2rem;
        top: 0;
        position:fixed;
        width: 100%;
        background-color: #2D7FC7;
        z-index:999;
    }
</style>